import { sortByBoolean, sortByDate, sortByLocalCompare, sortByNumber, } from './utility/table-sort.utils';
export { Table as TableV2 } from './table.component';
export { useTableConfig } from './hooks/use-table-config.hook';
export const sortUtility = {
    sortByBoolean,
    sortByDate,
    sortByLocalCompare,
    sortByNumber,
};
